<div class="container">
  <ng-container *ngIf="!isLoading; else loader">
    <div class="top-part">
      <div *ngIf="!showManualDownload">
        <div class="flex-centered">
          <h2>{{ 'consent.downloadLegalDocument.headline' | transloco }}</h2>
        </div>
      </div>
      <div *ngIf="showManualDownload">
        <div class="flex-centered">
          <h2>
            {{
              'consent.downloadLegalDocument.popupBlocked.headline' | transloco
            }}
          </h2>
        </div>

        <div class="flex-centered">
          <markant-button (click)="downloadContentManual()">{{
            'consent.downloadLegalDocument.popupBlocked.buttonText' | transloco
          }}</markant-button>
        </div>
      </div>
      <div class="flex-centered dashboard-button">
        <markant-button
          (click)="toDashboard()"
          colorScheme="primary"
          [variant]="showManualDownload ? 'clear' : 'solid'"
        >
          <markant-icon
            icon="m_login"
            class="login-icon"
            slot="icon-leading"
          ></markant-icon>
          {{ 'consent.downloadLegalDocument.buttonText' | transloco }}
        </markant-button>
      </div>
    </div>
  </ng-container>
  <ng-template #loader>
    <markant-spinner />
  </ng-template>
</div>
